export default __webpack_public_path__ + "static/media/ua.af1d11da.svg";